import { render, staticRenderFns } from "./projectListing.vue?vue&type=template&id=87966020&scoped=true"
import script from "./projectListing.vue?vue&type=script&lang=js"
export * from "./projectListing.vue?vue&type=script&lang=js"
import style0 from "./projectListing.vue?vue&type=style&index=0&id=87966020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87966020",
  null
  
)

export default component.exports